import britex from "../assets/img/favicon.png";
const _britex = (props) => {
    const { img } = props;
    if (img != undefined) {
        if (img.length > 10) {
            return "data:image/png;base64," + img;
        } else {
            return britex;
        }
    } else {
        return britex;
    }
}
export default _britex;